export default "__VITE_ASSET__B$wInkoU__"